


















import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { VIPCompany, vip } from "@/loader/public";
import CompanyEdit from "./CompanyEdit.vue";
import { BvModalEvent } from "bootstrap-vue";
import { VIPCompanyRefreshTableMixin } from '@/mixins/VIPCompanyMixin';

@Component({
	components: {
		CompanyEdit,
	},
})
export default class CompanyModal extends Vue {
	@Ref()
	public readonly editor!: CompanyEdit;

	public get item(): VIPCompany | null {
		return vip.company;
	}

	public onHide(e: BvModalEvent) {
		if (e.trigger === "backdrop" || e.trigger === "headerclose") {
			this.editor.cancel();
		}
	}

	public show() {
		this.$bvModal.show(this.id);
	}

	public hide(event: string = "") {
		this.$bvModal.hide(this.id);
		if (event) {
			this.$emit(event, this.item);
		}
	}
}
